var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgAppQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254,
    height: 254,
    viewBox: "0 0 254 254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#193F6F",
    transform: "translate(26 26)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(105 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(105 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 21)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 21)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 21)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 21)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 21)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 21)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 35)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98 35)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 35)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 35)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 35)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(105 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 49)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(14 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(21 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(35 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(42 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(105 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(0 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(14 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(21 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(49 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(42 70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(49 70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(21 77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(0 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(28 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(35 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(42 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 84)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(0 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(14 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(21 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(0 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(14 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(21 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(42 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(49 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 98)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(0 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(35 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(49 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 105)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(35 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(42 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 112)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(14 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(28 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(35 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 119)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(0 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(14 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(35 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(42 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(49 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 126)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(21 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(28 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(49 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 133)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(7 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(35 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(42 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(49 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 140)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 147)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 154)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 161)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 161)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 161)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 161)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 161)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 161)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(105 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(91 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(105 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(119 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(182 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 175)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(112 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(196 182)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(56 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(70 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(105 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(168 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 189)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(63 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(77 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(84 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(98 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(126 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(133 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(140 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(147 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(154 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(161 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(175 196)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "translate(189 196)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.3850623,7.31550658 C33.7962341,7.31550658 41.4532774,14.9725586 41.4532774,24.3850796 C41.4532774,33.7962168 33.7962341,41.4519714 24.3850623,41.4519714 C14.9725586,41.4519714 7.31551523,33.7962168 7.31551523,24.3850796 C7.31551523,14.9725586 14.9725586,7.31550658 24.3850623,7.31550658 M24.3850623,48.767478 C37.8506696,48.767478 48.7688013,37.8506523 48.7688013,24.3850796 C48.7688013,10.9181231 37.8506696,-3.55271368e-15 24.3850623,-3.55271368e-15 C10.9181317,-3.55271368e-15 -3.55271368e-15,10.9181231 -3.55271368e-15,24.3850796 C-3.55271368e-15,37.8506523 10.9181317,48.767478 24.3850623,48.767478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1760268,34.6252147 C29.9473832,34.6252147 34.6250677,29.946155 34.6250677,24.1748246 C34.6250677,18.4034942 29.9473832,13.7244345 24.1760268,13.7244345 C18.4046791,13.7244345 13.7256627,18.4034942 13.7256627,24.1748246 C13.7256627,29.946155 18.4046791,34.6252147 24.1760268,34.6252147"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3850623,7.31550658 C33.7962341,7.31550658 41.4532774,14.9725586 41.4532774,24.3850796 C41.4532774,33.7962168 33.7962341,41.4519714 24.3850623,41.4519714 C14.9725586,41.4519714 7.31551523,33.7962168 7.31551523,24.3850796 C7.31551523,14.9725586 14.9725586,7.31550658 24.3850623,7.31550658 M24.3850623,48.767478 C37.8506696,48.767478 48.7688013,37.8506523 48.7688013,24.3850796 C48.7688013,10.9181231 37.8506696,-3.55271368e-15 24.3850623,-3.55271368e-15 C10.9181317,-3.55271368e-15 -3.55271368e-15,10.9181231 -3.55271368e-15,24.3850796 C-3.55271368e-15,37.8506523 10.9181317,48.767478 24.3850623,48.767478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1760268,34.6252147 C29.9473832,34.6252147 34.6250677,29.946155 34.6250677,24.1748246 C34.6250677,18.4034942 29.9473832,13.7244345 24.1760268,13.7244345 C18.4046791,13.7244345 13.7256627,18.4034942 13.7256627,24.1748246 C13.7256627,29.946155 18.4046791,34.6252147 24.1760268,34.6252147"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3850623,7.31550658 C33.7962341,7.31550658 41.4532774,14.9725586 41.4532774,24.3850796 C41.4532774,33.7962168 33.7962341,41.4519714 24.3850623,41.4519714 C14.9725586,41.4519714 7.31551523,33.7962168 7.31551523,24.3850796 C7.31551523,14.9725586 14.9725586,7.31550658 24.3850623,7.31550658 M24.3850623,48.767478 C37.8506696,48.767478 48.7688013,37.8506523 48.7688013,24.3850796 C48.7688013,10.9181231 37.8506696,-3.55271368e-15 24.3850623,-3.55271368e-15 C10.9181317,-3.55271368e-15 -3.55271368e-15,10.9181231 -3.55271368e-15,24.3850796 C-3.55271368e-15,37.8506523 10.9181317,48.767478 24.3850623,48.767478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1760268,34.6252147 C29.9473832,34.6252147 34.6250677,29.946155 34.6250677,24.1748246 C34.6250677,18.4034942 29.9473832,13.7244345 24.1760268,13.7244345 C18.4046791,13.7244345 13.7256627,18.4034942 13.7256627,24.1748246 C13.7256627,29.946155 18.4046791,34.6252147 24.1760268,34.6252147"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.390026,100.1962 C127.390026,114.662844 115.66277,126.391213 101.195013,126.391213 C86.7283695,126.391213 75,114.662844 75,100.1962 C75,85.7294825 86.7283695,74 101.195013,74 C115.66277,74 127.390026,85.7294825 127.390026,100.1962 Z M101.195533,120.317685 C101.510197,120.317685 101.829388,120.308559 102.141753,120.291494 C102.454118,120.273242 102.769895,120.24705 103.077734,120.211659 C103.385499,120.176342 103.694451,120.133011 104.001102,120.080555 C104.305528,120.029285 104.60988,119.967703 104.909705,119.899294 C105.207231,119.830886 105.505944,119.754538 105.800056,119.670177 C106.094169,119.584704 106.388281,119.49233 106.674455,119.392017 C106.959442,119.294004 107.246728,119.185678 107.529414,119.069413 C107.807575,118.956561 108.088035,118.832283 108.36167,118.702292 C108.63293,118.574601 108.907678,118.43667 109.174486,118.293027 C109.43892,118.150571 109.704542,117.997802 109.962224,117.841619 C110.219832,117.684324 110.477515,117.520128 110.72711,117.349107 C110.976779,117.180385 111.225335,117.002538 111.468178,116.820164 C111.708721,116.637791 111.948077,116.447404 112.180682,116.253604 C112.413212,116.059804 112.643516,115.856879 112.865807,115.651653 C113.089211,115.446427 113.310389,115.232149 113.52474,115.015571 C113.737905,114.797806 113.949957,114.573215 114.152883,114.345211 C114.356922,114.11832 114.558735,113.881264 114.752534,113.644134 C114.945147,113.407004 115.135534,113.161861 115.319094,112.913379 C115.501468,112.66601 115.681615,112.409514 115.85375,112.151832 C116.026997,111.894224 116.194606,111.629715 116.355314,111.364094 C116.918535,110.435013 116.623236,109.219758 115.690742,108.662324 C114.4789,107.939508 113.550932,108.397816 112.988898,109.326897 C112.857793,109.542362 112.722163,109.755527 112.583046,109.963053 C112.445116,110.170504 112.30036,110.37573 112.153303,110.574056 C112.006247,110.773569 111.854591,110.970781 111.699595,111.161168 C111.544526,111.350442 111.383818,111.538529 111.220735,111.720902 C111.058914,111.90105 110.891305,112.08001 110.720284,112.253332 C110.551562,112.425466 110.376015,112.595301 110.198167,112.758309 C110.02262,112.920205 109.841359,113.0798 109.657798,113.232569 C109.475425,113.386452 109.286151,113.536921 109.096951,113.679451 C108.907678,113.821982 108.712765,113.961025 108.517852,114.094429 C108.321753,114.226646 108.121127,114.35545 107.920427,114.476315 C107.720988,114.598293 107.514575,114.716859 107.308236,114.82741 C107.103085,114.938037 106.891033,115.045175 106.681281,115.144375 C106.469229,115.244688 106.253764,115.339288 106.038299,115.427062 C105.822834,115.516023 105.600543,115.599196 105.381666,115.675618 C105.161675,115.751966 104.937084,115.823787 104.713606,115.886483 C104.489015,115.952591 104.259898,116.011874 104.031894,116.063217 C103.80389,116.114487 103.570173,116.16123 103.339943,116.201148 C103.106226,116.241065 102.869095,116.274082 102.634265,116.301461 C102.399435,116.327652 102.158892,116.349317 101.920575,116.361856 C101.440676,116.389234 100.950463,116.389234 100.469377,116.361856 C100.231134,116.349317 99.990591,116.327652 99.7545738,116.301461 C99.5209309,116.274082 99.2838008,116.241065 99.0511966,116.202261 C98.8197796,116.16123 98.5860625,116.114487 98.3592456,116.063217 C98.1312416,116.011874 97.9009375,115.952591 97.6775336,115.88767 C97.4529426,115.823787 97.2283516,115.751966 97.0071736,115.675618 C96.7894828,115.599196 96.5683048,115.516023 96.3528399,115.427062 C96.137375,115.339288 95.9207971,115.244688 95.7098582,115.144375 C95.4989934,115.045175 95.2880545,114.938037 95.0817156,114.82741 C94.8753768,114.716859 94.669038,114.598293 94.4695252,114.476315 C94.2688995,114.35545 94.0682738,114.226646 93.872174,114.093242 C93.6772613,113.961025 93.4822745,113.821982 93.2930749,113.679451 C93.1038012,113.536921 92.9157145,113.386452 92.7321539,113.233682 C92.5497803,113.0798 92.3674068,112.920205 92.1906721,112.757196 C92.0139375,112.595301 91.8395771,112.425466 91.6696685,112.253332 C91.4998341,112.08001 91.3311126,111.90105 91.1692171,111.719789 C91.0062087,111.538529 90.8455004,111.350442 90.6904309,111.160055 C90.5365486,110.970781 90.3837792,110.773569 90.236723,110.574056 C90.0907796,110.37573 89.9460234,110.170504 89.8069061,109.963053 C89.6678629,109.755527 89.5321586,109.542362 89.4022416,109.326897 C88.8390947,108.397816 87.8381177,107.95546 86.6992847,108.662324 C85.7770296,109.234597 85.4726038,110.435013 86.0346378,111.364094 C86.1954203,111.629715 86.3641418,111.894224 86.5373893,112.153019 C86.7095238,112.409514 86.8884843,112.66601 87.070932,112.913379 C87.2544185,113.161861 87.4448052,113.407004 87.637492,113.644134 C87.8312917,113.881264 88.0331045,114.11832 88.2371433,114.345211 C88.441182,114.573215 88.652121,114.797806 88.8663988,115.015571 C89.0796378,115.232149 89.3007416,115.446427 89.5230325,115.65054 C89.7465106,115.856879 89.9768147,116.059804 90.2093447,116.254717 C90.4418746,116.447404 90.6813048,116.637791 90.9229609,116.821277 C91.1646912,117.002538 91.4131732,117.180385 91.6628425,117.349107 C91.9125117,117.520128 92.1701199,117.684324 92.4278023,117.841619 C92.6854105,117.997802 92.9510318,118.150571 93.2166531,118.293027 C93.4834616,118.43667 93.7570219,118.574601 94.0283564,118.702292 C94.3019909,118.83117 94.5823772,118.955374 94.8617248,119.069413 C95.1444112,119.185678 95.4316977,119.294004 95.7155713,119.392017 C96.0028578,119.49233 96.2969704,119.584704 96.58997,119.670177 C96.8840826,119.754538 97.1827211,119.830886 97.4814338,119.900481 C97.7801466,119.967703 98.0844982,120.029285 98.3888498,120.080555 C98.6955015,120.133011 99.0044532,120.176342 99.3111049,120.211659 C99.6200567,120.24705 99.9358344,120.273242 100.247086,120.291494 C100.560564,120.308559 100.880942,120.317685 101.195533,120.317685 Z M108.613342,95.3432686 C110.08398,95.3432686 111.280982,96.5402712 111.280982,98.0109083 C111.280982,99.4814711 110.08398,100.678474 108.613342,100.678474 C107.142705,100.678474 105.945703,99.4814711 105.945703,98.0109083 C105.945703,96.5402712 107.142705,95.3432686 108.613342,95.3432686 Z M108.613342,104.462168 C112.171333,104.462168 115.064602,101.567712 115.064602,98.0109083 C115.064602,94.4541049 112.171333,91.5595742 108.613342,91.5595742 C105.056539,91.5595742 102.163196,94.4541049 102.163196,98.0109083 C102.163196,101.567712 105.056539,104.462168 108.613342,104.462168 Z M93.8245402,92.0357635 L93.8245402,95.0852895 C93.8245402,95.2278198 93.9408052,95.3429719 94.0833355,95.3429719 L96.4237712,95.3429719 L96.4237712,97.856655 C96.4237712,99.2919006 95.2495468,100.496916 93.8154141,100.471838 C92.4223118,100.448986 91.2948308,99.3078527 91.2948308,97.9079243 L91.2948308,88.8802858 C91.2948308,87.4518662 92.4645292,86.2479635 93.8917617,86.2651027 C95.2005033,86.2821678 96.2755278,87.2842577 96.410045,88.562208 C96.4225841,88.6944251 96.5309101,88.797038 96.6643143,88.797038 L100.146996,88.797038 C100.294052,88.797038 100.411504,88.673947 100.404604,88.5268907 C100.245009,85.0281827 97.3288871,82.2363392 93.7835099,82.2761824 C90.1799631,82.3183999 87.3048717,85.3097562 87.3048717,88.913303 L87.3048717,97.8247507 C87.3048717,101.432823 90.1867891,104.42648 93.7948618,104.461871 C97.438326,104.497189 100.412617,101.54345 100.412617,97.9079243 L100.412617,95.3429719 L100.417143,95.3429719 L100.417143,91.9069594 C100.417143,91.8351378 100.359048,91.7770424 100.288339,91.7770424 L94.0833355,91.7770424 C93.9408052,91.7770424 93.8245402,91.8933074 93.8245402,92.0357635 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8,
    x: 210
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8,
    x: 210,
    y: 246
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8,
    y: 246
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8,
    x: -18,
    y: 18,
    transform: "rotate(90 4 22)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8,
    x: 228,
    y: 18,
    transform: "rotate(90 250 22)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8,
    x: 228,
    y: 228,
    transform: "rotate(90 250 232)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 8,
    x: -18,
    y: 228,
    transform: "rotate(90 4 232)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAppQrcode);
export default __webpack_public_path__ + "static/media/img-app-qrcode.c277a435399031ca69d50e31557c8ac3.svg";
export { ForwardRef as ReactComponent };